// @ts-nocheck
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useState} from "react";
import {postAccountPagoMovil} from "../../services/wallet/accounts";

const useCreateAccPagoMovil = () => {
  const queryClient = useQueryClient();
  const [result, setResult] = useState();
  const {isError, isPending, isSuccess, refetch, error, mutate} = useMutation({
    mutationKey: ["postMobileAccount"],
    mutationFn: postAccountPagoMovil,
    onSuccess: data => {
      queryClient.invalidateQueries({queryKey: ["userMobileAccount"]});
      setResult(data?.data.data);
    },
  });

  return {data: result, isError, isPending, refetch, isSuccess, error, mutate};
};

export default useCreateAccPagoMovil;
